import PageHero from "../components/PageHero";
import Pricing from "../components/Pricing";
import Faq from "../components/Faq";
import SmartLink from "../components/SmartLink";
import { pricing } from "../lib/content";

export default function PricingPage() {
  return (
    <>
      <PageHero eyebrow={pricing.eyebrow} title={pricing.heading} intro={pricing.subheading} />

      <Pricing withHeader={false} />

      <Faq />

      <section className="section-pad bg-white">
        <div className="container-page">
          <div className="card mx-auto max-w-3xl p-8 text-center shadow-card sm:p-12">
            <h2 className="text-2xl font-bold tracking-tight text-ink sm:text-3xl">
              {pricing.stillHaveQuestions.heading}
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-ink-muted">
              {pricing.stillHaveQuestions.body}
            </p>
            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <SmartLink
                href={pricing.stillHaveQuestions.primaryCta.href}
                className="btn-primary w-full sm:w-auto"
              >
                {pricing.stillHaveQuestions.primaryCta.label}
              </SmartLink>
              <SmartLink
                href={pricing.stillHaveQuestions.secondaryCta.href}
                className="btn-ghost w-full sm:w-auto"
              >
                {pricing.stillHaveQuestions.secondaryCta.label}
              </SmartLink>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
